import baseConstants from './constants.base'

const constants = {
  ...baseConstants,
  backendHost: 'http://localhost',
}

export default constants



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/config/constants.Test.js